import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Rocket } from "lucide-react";
import api from "@/lib/api";
import { NpiTab } from "@/components/NpiTab";
import { NpiLessons } from "@/components/NpiLessons";

export default function Npi() {
  const [tab, setTab] = useState("tracker");
  const nq = useQuery({ queryKey: ["npi", "all"], queryFn: async () => (await api.get("/npi")).data, enabled: tab === "lessons" });
  return (
    <div className="space-y-6" data-testid="npi-page">
      <div><div className="pp-label text-blue-400">New product introduction</div><h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight flex items-center gap-3"><Rocket className="text-blue-400" /> NPI Projects</h1><p className="text-sm text-slate-500 mt-1">Month-on-month NPI tracker with quantities done, customer-wise TAT and trail delay / iteration checks.</p></div>
      <div className="flex flex-wrap gap-1">{[["tracker", "NPI tracker"], ["lessons", "Lessons learnt · CTP / CTQ"]].map(([k, l]) => <button key={k} className={`rounded-full px-3 py-1.5 text-xs font-semibold ${tab === k ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`} onClick={() => setTab(k)} data-testid={`npi-tab-${k}`}>{l}</button>)}</div>
      {tab === "tracker" ? <NpiTab /> : <NpiLessons npis={nq.data?.rows || []} />}
    </div>
  );
}
